var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DashboardWidget", {
    attrs: { id: "recommendations", items: _vm.recommendedFiles },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var item = ref.item
          return [
            _c("RecommendedFile", {
              key: item.id,
              attrs: {
                id: item.id,
                extension: item.extension,
                "mime-type": item.mimeType,
                name: item.name,
                directory: item.directory,
                reason: item.reason,
                "has-preview": item.hasPreview
              }
            })
          ]
        }
      },
      {
        key: "empty-content",
        fn: function() {
          return [
            _c("EmptyContent", {
              attrs: {
                id: "recommendations--empty-content",
                icon: "icon-files-dark"
              },
              scopedSlots: _vm._u([
                {
                  key: "desc",
                  fn: function() {
                    return [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(
                            _vm.t("recommendations", "No recommendations yet")
                          ) +
                          "\n\t\t\t"
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }